/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ lappuse',
  jump_to: 'iet uz',
  jump_to_confirm: 'apstiprinÄt',
  page: '',

  // Pagination.jsx
  prev_page: 'IepriekÅ¡ÄjÄ lapa',
  next_page: 'NÄkamÄ lapaspuse',
  prev_5: 'IepriekÅ¡ÄjÄs 5 lapas',
  next_5: 'NÄkamÄs 5 lapas',
  prev_3: 'IepriekÅ¡ÄjÄs 3 lapas',
  next_3: 'NÄkamÄs 3 lapas'
};
